"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_actions_1 = __importDefault(require("../../redux/scenario/scenario.actions"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var scenario_node_footer_button_box_component_1 = __importDefault(require("./scenario-node-footer-button-box.component"));

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var ScenarioNodeFooterButtonBoxContainer = function ScenarioNodeFooterButtonBoxContainer(_ref) {
  var node = _ref.node;
  var dispatch = react_redux_1.useDispatch();
  var design = react_redux_1.useSelector(scenario_selectors_1.selectDesign);
  var moveParentNode = !!node.parentId ? function () {
    dispatch(scenario_actions_1.default.moveNode({
      nextNodeId: node.parentId
    }));
  } : undefined;

  var moveTopNode = function moveTopNode() {
    dispatch(scenario_actions_1.default.moveNode({
      nextNodeId: scenario_state_1.GREETING_SCENARIO_NODE_ID
    }));
  };

  return react_1.default.createElement(scenario_node_footer_button_box_component_1.default, {
    preButtonColor: design.textScenarioNode.preButtonColor,
    initButtonColor: design.textScenarioNode.initButtonColor,
    onPreClick: moveParentNode,
    onInitClick: moveTopNode
  });
};

exports.default = ScenarioNodeFooterButtonBoxContainer;